export default __webpack_public_path__ + "static/media/BadgesActive.dbcd7d17.svg";